<template>
  <svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   :width="width"
   :height="height"
   viewBox="0 0 360 400"
   version="1.1"
   id="svg1118"
   sodipodi:docname="tongue_L_round_4.svg"
   inkscape:version="1.0rc1 (09960d6, 2020-04-09)">
  <defs
     id="defs1112">
     <filter id="blur">
         <feGaussianBlur in="SourceGraphic" stdDeviation="7,7" />
      </filter>
  </defs>
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="0.98994949"
     inkscape:cx="32.304477"
     inkscape:cy="187.25371"
     inkscape:document-units="px"
     inkscape:current-layer="layer1"
     inkscape:document-rotation="0"
     showgrid="false"
     units="px"
     scale-x="1"
     inkscape:window-width="1252"
     inkscape:window-height="755"
     inkscape:window-x="0"
     inkscape:window-y="23"
     inkscape:window-maximized="0" />
  <metadata
     id="metadata1115">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
   <path
       id="outside"
       style="fill:#ff000000;stroke:#ffffff;stroke-width:0.996347;stroke-opacity:1"
       d="M 0.49804688 0.49804688 L 0.49804688 399.50195 L 359.50195 399.50195 L 359.50195 0.49804688 L 0.49804688 0.49804688 z M 233.96289 22.080078 C 247.52002 21.873251 260.90548 30.236107 277.40234 62.482422 C 321.97234 149.60316 281.48543 376.90158 179.61719 377.91992 C 76.730624 373.84657 38.567943 149.17576 82.785156 61.927734 C 117.03658 -5.6560941 143.67085 33.411903 182.42383 33.505859 C 203.01135 33.555773 218.59814 22.314482 233.96289 22.080078 z " />
   <path
       d="M 180 8.7871094 C 117.76101 8.7872428 67.307033 23.06088 67.308594 40.667969 C 67.309209 44.172234 69.354036 47.632602 73.294922 50.916016 C 109.96804 1.1915707 140.19737 34.844801 182.86328 34.931641 C 225.45643 35.018333 249.92493 0.77192744 286.61523 50.994141 C 290.61686 47.687824 292.69101 44.199899 292.69141 40.667969 C 292.69297 23.06088 242.23899 8.7872422 180 8.7871094 z "
       style="fill:#280b0b;stroke:#000000;stroke-width:0.879489;stroke-opacity:1"
       id="mouth" />
  <g id="cover_layer">
   <path
       sodipodi:nodetypes="scsss"
       inkscape:connector-curvature="0"
       id="cover"
       d="M 73.48521,62.036511 C 25.037618,138.7509 66.851534,336.2972 179.58153,339.87875 291.19578,338.98335 335.55475,139.12678 286.72061,62.524321 248.16027,2.0375956 225.11737,37.128819 182.65676,37.046204 140.19618,36.963592 111.01353,2.6122126 73.48521,62.036511 Z"
       style="display:inline;fill:none;stroke:#ff000000;stroke-width:2.1204px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
  </g>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="body_layer">
    <path
       style="display:inline;fill:#f59a9a;stroke:#ff000000;stroke-width:2.33761px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
       d="M 65.1908,63.109954 C 12.970565,149.61085 58.040555,372.35824 179.54891,376.39671 299.85463,375.38708 347.66786,150.03468 295.03097,63.659994 253.46792,-4.5430583 228.63064,35.024771 182.86362,34.931619 137.09661,34.838468 105.64149,-3.8951363 65.1908,63.109954 Z"
       id="body"
       inkscape:connector-curvature="0"
       sodipodi:nodetypes="scsss" />
    <path
       inkscape:connector-curvature="0"
       id="lg"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 180.63764,280.70286 c -32.38012,-0.0659 -64.55573,8.89592 -98.539605,28.2603 8.178672,13.85911 17.625715,26.25084 28.301335,36.51957 51.49505,-15.48254 97.62138,-14.22686 139.70687,-0.36895 11.1148,-10.91641 20.9021,-24.21258 29.31285,-39.0885 -34.44114,-16.35215 -66.71532,-25.25637 -98.78145,-25.32242 z" />
    <path
       id="he"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 183.95121,334.03571 c -23.40195,-0.21051 -48.00497,3.31765 -73.96575,11.08588 19.24156,18.65515 42.49778,30.39496 69.54301,31.29383 27.39561,-0.2299 51.03047,-12.09538 70.57777,-31.30164 -20.99167,-6.99824 -42.98583,-10.86965 -66.15503,-11.07807 z"
       inkscape:connector-curvature="0" />
    <path
       inkscape:connector-curvature="0"
       id="k-bl-li"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="M 243.73025,23.603849 C 225.58458,23.836246 207.17669,34.98127 182.86297,34.931783 137.09595,34.838633 105.6414,-3.8949964 65.190705,63.110094 60.872484,70.263078 57.233318,78.363676 54.233855,87.179272 152.74497,102.19418 231.67326,97.097753 305.80669,87.073859 302.85464,78.496617 299.27373,70.622368 295.03121,63.660582 275.54853,31.6904 259.74113,23.398793 243.73025,23.603849 Z" />
    <path
       inkscape:connector-curvature="0"
       id="lv-gb-l"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 305.90435,87.37448 -46.05042,5.233533 c 16.37688,76.184807 11.70294,138.919417 -1.22543,204.170257 l 20.672,9.45198 c 16.56495,-29.22464 27.78886,-64.5839 33.20308,-100.10474 2.31073,-20.67833 3.30069,-41.44795 3.44378,-61.17046 -0.94951,-20.98197 -4.25825,-40.65622 -10.04301,-57.58057 z" />
    <path
       inkscape:connector-curvature="0"
       id="lv-gb-r"
       style="display:inline;fill:none;stroke:#000000;stroke-width:1.09084;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       d="m 54.15712,87.413522 c -5.370445,15.867838 -8.637235,34.079258 -9.854659,53.492908 -0.03838,22.19098 0.956093,45.78377 3.678639,69.15449 5.702105,35.18537 17.117896,69.97059 33.926255,98.5704 L 100.77492,298.59761 C 88.718755,229.14368 85.013428,165.17206 99.04256,92.980861 Z" />
    <path
       sodipodi:nodetypes="cccccc"
       inkscape:connector-curvature="0"
       d="M 100.77805,298.59882 C 88.721886,229.14497 85.016226,165.1704 99.045358,92.979193 158.44052,98.535803 210.74588,97.146434 259.85971,92.633115 276.22935,168.80523 271.55566,231.53558 258.62894,296.7784 198.2707,273.69138 155.88995,276.19296 100.77805,298.59851 Z"
       style="display:inline;fill:none;stroke:#000000;stroke-width:0.83935;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
       :style="{display: fragmented ? 'inline' : 'none'}"
       id="st-sp" />
  </g>
</svg>
</template>

<script>
export default {
   props: {
      fragmented: {
         default: false
      },
      height: {
         default: 400
      },
      width: {
         default: 360
      }
   },
	mounted() {
		this.$emit('mounted');
	}
}
</script>